import type { IconType } from 'react-icons';
import { LuWaves } from 'react-icons/lu';

import { UnitInput } from '@/components/UnitInput/UnitInput';

import type { TankLevels } from '../types';

import { SectionHeader } from './SectionHeader';
import s from './TankLevelsSection.module.scss';

interface TankLevelsSectionProps {
  values: TankLevels;
  onChange: (key: keyof TankLevels, val: string) => void;
  icon?: IconType;
}

const TANKS: Array<{ key: keyof TankLevels; label: string }> = [
  { key: 'fuel', label: 'Fuel' },
  { key: 'water', label: 'Water' },
  { key: 'greyWater', label: 'Gray Water' },
  { key: 'blackWater', label: 'Black Water' },
];

export function TankLevelsSection({
  values,
  onChange,
  icon: Icon = LuWaves,
}: TankLevelsSectionProps) {
  return (
    <div className={s.section}>
      <SectionHeader icon={Icon} title="Tank Levels" />

      <div className={s.rows}>
        {TANKS.map(({ key, label }) => (
          <div key={key} className={s.row}>
            <label className={s.label}>{label}</label>
            <UnitInput
              kind="volume"
              type="number"
              value={values[key]}
              onChange={(v) => onChange(key, v)}
              className={s.input}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
